const video = $(".video");
const mobileVideoID = $('video-js').attr('data-video-id-mobile');
const isMobileDeviceWithTablet = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|iPad/i.test(navigator.userAgent);

//- Handle About Section Dom position for mobile and desktop
const vslContainer = $('#vslSectionVsl');
const vslPlayCta = $('#playCTA');
const videoPlayer = videojs('vslSectionVsl');
const breakPoint = 768;

let windowW = window.innerWidth;

let isPlaying = false;

//- Handle cookies for VSL Play button
if (!$.cookie('oliveoil-vsl-rc')) {
  videojs($('#vslContainer video-js').attr('id')).ready(function () {
    this.on('timeupdate', function () {
      if (this.currentTime() >= (60 * timePlaying) || this.currentTime() == this.duration()) {
        if (typeof loadIframe !== 'undefined' && loadIframe == true) {
          $("#vslContent").addClass('hidden');
          $("#ecomIframe").removeClass('iframe__hidden');

          if (windowW <= 1024) {
            $("#about").addClass('hidden');
          }

        } else {
          $("#vslCTA").removeClass('hide');
        }
      }
    })
  });
  $.cookie("oliveoil-vsl-rc", 1, { expires: 7 });
}
else {
  if (typeof loadIframe !== 'undefined' && loadIframe == true) {
    $("#vslContent").addClass('hidden');
    $("#ecomIframe").removeClass('iframe__hidden');

    if (windowW <= 1024) {
      $("#about").addClass('hidden');
    }

  } else {
    $("#vslCTA").removeClass('hide');
  }
}

vslContainer.on('touchstart click', function () {
  hideVideoPlayButton();
})

vslPlayCta.on('click', function () {
  playVideo();
  changeVslOnMobile(true);
  hideVideoPlayButton();

  if (typeof isFullScreenInlineDesktop !== 'undefined' && isFullScreenInlineDesktop == true && !isMobileDeviceWithTablet || typeof isFullScreenInlineMobile !== 'undefined' && isFullScreenInlineMobile == true && isMobileDeviceWithTablet) {
    fullScreenVsl();

  } else if (isMobileDeviceWithTablet) {
    if (isPlaying) {
      videoPlayer.pause();
      // console.log(videoPlayer.currentTime());
    } else {
      videoPlayer.play();
      // console.log(videoPlayer.currentTime());
    }
    isPlaying = !isPlaying;
  }
})

function playVideo() {
  videojs.getPlayer('vslSectionVsl').ready(function () {
    var myPlayer = this;

    myPlayer.play();
  });
}

function hideVideoPlayButton() {
  vslPlayCta.hide();
}

//- Different VSL on mobile and desktop
const changeVslOnMobile = (play) => {
  if (typeof mobileVideoID !== 'undefined' && mobileVideoID != '') {
    let isMobileDevice = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobileDevice) {
      const myPlayer = videojs.getPlayer($('video-js').attr('id'))
      if (window.innerHeight > window.innerWidth) {
        myPlayer.catalog.getVideo(mobileVideoID, function (error, video) {
          myPlayer.catalog.load(video);
          play ? myPlayer.play() : null;
        });
      }
    }
  };
}

function fullScreenVsl() {
  window.scrollTo(0, 0);
  if ($('body').hasClass('fullScreenVsl')) {
    videoPlayer.pause();
    $('.vjs-big-play-button').show();
    $('body').removeClass('fullScreenVsl');

    // console.log(videoPlayer.currentTime());

    return

  } else {
    videoPlayer.play();
    $('.vjs-big-play-button').hide();
    $('body').addClass('fullScreenVsl');

    // console.log(videoPlayer.currentTime());

    return
  };
}

//- Full screen VSL
const handleFullScreenInline = (videoEl) => {
  let startScrollTop,
    endScrollTop;

  videoEl.on("touchstart", function () {
    startScrollTop = $(window).scrollTop();
  });

  videoEl.on('touchend', function () {
    endScrollTop = $(window).scrollTop();
  });

  videoEl.on('click touchend', function () {
    if (startScrollTop === endScrollTop) {
      fullScreenVsl();
    }
  });

  videoEl.one('click touchend', function () {
    changeVslOnMobile(true);
    hideVideoPlayButton();
  });
}

const videoPlayPause = (videoEl) => {
  videoEl.on('click touchend', function () {
    if (isPlaying) {
      videoPlayer.pause();
      // console.log(videoPlayer.currentTime());
    } else {
      videoPlayer.play();
      // console.log(videoPlayer.currentTime());
    }
    isPlaying = !isPlaying;
  });
}

if (typeof isFullScreenInlineDesktop !== 'undefined' && isFullScreenInlineDesktop == true && !isMobileDeviceWithTablet || typeof isFullScreenInlineMobile !== 'undefined' && isFullScreenInlineMobile == true && isMobileDeviceWithTablet) {
  handleFullScreenInline(video)
} else if (isMobileDeviceWithTablet) {
  videoPlayPause(video)
}

changeVslOnMobile();

//-----------------------------------------------------------
//- Detect when video reach the defined time and change UTM
//-----------------------------------------------------------
if(setPlayedTime === true) {
  function returnPlayedTime() {
    if (typeof playVideoMinutes !== 'undefined' && playVideoSeconds !== 'undefined') {
      let playVideoMinutesInSeconds = playVideoMinutes * 60,
          targetPlayTimeInSeconds = playVideoMinutesInSeconds + playVideoSeconds,
          currentTime = videoPlayer.currentTime();

      // console.log('currentTime', currentTime);

      // Check if the current play time is greater than the targeted time
      if (currentTime > targetPlayTimeInSeconds) {
        // console.log('originalUtmContent', originalUtmContent);
        // console.log('targetPlayTimeInSeconds', targetPlayTimeInSeconds);

        if (typeof originalUtmContent !== 'undefined') {

          const splitFullOriginalUtmContent = originalUtmContent.split('-');

          let newUtmContent = splitFullOriginalUtmContent[0] + '-' + splitFullOriginalUtmContent[1] + '-' + splitFullOriginalUtmContent[2] + '-' + splitFullOriginalUtmContent[3] + playVideoMinutes + '-' + splitFullOriginalUtmContent[4];

          // console.log('>> New UTM Content', newUtmContent);

          $('[data-param]').each(function (index) {
            const paramTargetPrefix = $(this).attr('data-param').split('utm_content=')[0];
            $(this).attr('data-param', `${paramTargetPrefix}utm_content=${newUtmContent}`);

            const hrefTargetPrefix = $(this).attr('href').split('utm_content=')[0];
            $(this).attr('href', `${hrefTargetPrefix}utm_content=${newUtmContent}`);
          });
        }

        clearInterval(interval);        
      }
    }
  }

  let interval = setInterval(returnPlayedTime, 1000);
}